<script setup lang="ts">
import SummaryCard from '@/components/payment-view/summary-card.vue';
import PaymentCard from '@/components/payment-view/payment-card.vue';
import useCountry from '@/composables/countryDependable';
import {loadPaypalScriptFile} from '@/core/paypal/paypal-script-injection';
import { useRouter } from 'vue-router';
import { useApplicationStore } from '@/store/application';
import RouteName from '@/router/route-name';
import { onBeforeMount, onMounted, ref } from 'vue';

const country = useCountry();
const router = useRouter();
const applicationStore = useApplicationStore();
const redirecting = ref(true);

onBeforeMount(() => {
    if (!applicationStore.validateApplication()) {
        router.push({ name: RouteName.APPLICATION_PROCESS });
    } else {
        redirecting.value = false;
    }
});

onMounted(() => {
    if (!redirecting.value) {
        loadPaypalScriptFile(country);
    }
});

</script>

<template>
    <SummaryCard class="my-3"/>
    <PaymentCard v-if="!redirecting" class="my-3"/>
</template>
